// extracted by mini-css-extract-plugin
module.exports = {"block":"_8830","desc":"_19831","title":"_19317","line":"_17258","text":"_19289","content":"_853","more":"_18606","arrow":"_4737","fold":"_9605"};